var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDetective = function SvgIconDetective(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.264 12.25h2.611a1 1 0 1 0 0-2H20.77L16.45 4.08l-.001-.002a1.75 1.75 0 0 0-2.887.024l-.003.005L12 6.451l-1.558-2.345-.003-.005a1.75 1.75 0 0 0-2.887-.024v.002L3.228 10.25H1.125a1 1 0 1 0 0 2h19.139M8.982 5.522l-3.31 4.728h12.657l-3.311-4.728-1.555 2.341a1.75 1.75 0 0 1-2.926 0zm5.825-.3h.001M3.5 17.063a3.437 3.437 0 0 1 6.727-1h3.546a3.44 3.44 0 0 1 6.727 1 3.437 3.437 0 0 1-6.727 1h-3.546a3.439 3.439 0 0 1-6.727-1m3.438-1.438a1.438 1.438 0 1 0 0 2.875 1.438 1.438 0 0 0 0-2.875m10.125 0a1.438 1.438 0 1 0 0 2.875 1.438 1.438 0 0 0 0-2.875"
  }))));
};
export default SvgIconDetective;